export default "__VITE_ASSET__MY2uSyos__"